/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../../../nls/StringResources',
	'react',
	'prop-types',
	'@ba/ba-ui-carbon-toolkit'
], function (_, stringResources, React, PropTypes, Toolkit) {

	const {
		FlexLayout,
		Label,
		NumberInput
	} = Toolkit;

	/**
	 * NumberOfResultsSection
	 * Properties:
	 * - min - minimum legal number
	 * - max - maximum legal number
	 * - value - current number
	 * - onValueChange - callback for when user specifies a new value
	 * - isPercent - indicates this number represents person, otherwise is a count
	 */
	class NumberOfResultsSection extends React.Component {
		static propTypes = {
			focusReady: PropTypes.object.isRequired,
			min: PropTypes.number.isRequired,
			max: PropTypes.number.isRequired,
			value: PropTypes.number,
			onValueChange: PropTypes.func.isRequired,
			isPercent: PropTypes.bool.isRequired
		}

		constructor(props) {
			super(props);

			this.numberInput = React.createRef();
			this.props.focusReady.then(() => this.onFocusReady());
		}

		onFocusReady() {
			this.numberInput.current.focus();
		}

		render() {
			const label = stringResources.get(
				this.props.isPercent ? 'topbottomPercentLabel' : 'topbottomNumberOfResultsLabel',
				{
					lower: this.props.min,
					higher: this.props.max
				}
			);
			return (
				<div className="numberOfResultsSection">
					<FlexLayout
						fullHeight
						direction='column'
						justifyContent='space-between'
					>
						<Label
							label={label}
							type='caption'
						/>
						<NumberInput
							className='aName'
							value={this.props.value}
							max={this.props.max}
							min={this.props.min}
							scale={0}
							// In order to leverage the toolkit nls strings we need to use onValueAccept prop instead of the onChange.
							// there are a number of benefits of using onValueAccept instead of onChange.
							// more details here: https://jsw.ibm.com/browse/CADBC-2054
							onValueAccept={v => this.props.onValueChange(v)}
							ref={this.numberInput}
							light
						/>
					</FlexLayout>
				</div>
			);
		}
	}

	return NumberOfResultsSection;
});
